export const LOCAL_STORAGE_CONNECTION_KEY = 'com.hmhco.security.sus.pid';
export const LOCAL_STORAGE_NONCE_KEY = 'com.hmhco.security.openID.nonce';
export const LOCAL_STORAGE_ORG_REF_ID_KEY = 'com.hmhco.org.ref.id';
export const SESSION_STORAGE_OKTA_CONFIG = 'com.hmhco.okta.config';
export const SESSION_STORAGE_STATE_KEY = 'com.hmhco.security.openID.state';
export const SESSION_STORAGE_CACHED_ORG_KEY = 'com.hmhco.cached.org.info';
export const SESSION_STORAGE_RESOURCE_URL_KEY =
  'com.hmhco.externalLaunch.resource.url';
export const SESSION_STORAGE_NEXT_BUTTON_PRESSED_KEY = 'com.hmhco.next.pressed';
